import { styled } from 'styled-components';
import { fadeInKeyframes } from '@inter-ikea-guida/framework';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
export const StyledPriceMayDiffer = styled.div `
  margin: ${SkapaTokens.space100} 0 ${SkapaTokens.space200};
`;
export const StyledResults = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledProductImageWrapper = styled.div `
  margin-bottom: ${SkapaTokens.space200};

  animation: ${fadeInKeyframes} 0.5s ease-in;
`;
//# sourceMappingURL=styles.js.map